/** Pending timeouts that are cancelled together (the debrief sequence). */
export class Timers {
  private readonly ids = new Set<number>();

  later(ms: number, run: () => void): void {
    const id = window.setTimeout(() => {
      this.ids.delete(id);
      run();
    }, ms);
    this.ids.add(id);
  }

  clear(): void {
    for (const id of this.ids) window.clearTimeout(id);
    this.ids.clear();
  }
}
